<template>
	<div class="extra">
		<div class="col-sm-3 no-padding">
			<div class="address-container">
				<p><strong>{{ render_billing_info.first_name }} {{ render_billing_info.last_name }}</strong></p>
				<p class="text-general">
					{{ render_billing_info.street }} {{ render_billing_info.ext_number }}<br>
					{{ render_billing_info.suburb }}<br>
					{{ render_billing_info.city_name }}, {{ render_billing_info.state_name }}, {{ render_billing_info.postal_code }}<br>
					{{ render_billing_info.phone_number }}
				</p>
			</div>
		</div>
		<div class="col-sm-4 col-sm-offset-5 text-right no-padding">
			<br><br>
			<button type="submit" @click="edit(render_billing_info, index)" class="btn btn-white btn-md">
		      	Editar
		    </button>
		    <button type="button" @click="remove(render_billing_info)" class="btn btn-white btn-md">
		      	Eliminar
		    </button>
		    <br><br>
		</div>
	</div>
</template>

<script>
export default {
	props: ['billing_info', 'remove', 'edit', 'index'],

	vuex: {
		getters: {
			states: state => state.states
		}
	},

	computed: {
		render_billing_info() {
			this.billing_info.state_name = this.getState();
			this.billing_info.city_name = this.billing_info.city.nom_mun;
			return this.billing_info;
		}
	},

	methods: {
		getState () {
			for (let i = 0, s = this.states; i < s.length; i++) {
				if (s[i].id == this.billing_info.city.ent_id) {
					return s[i].nom_ent;
				}
			}			
		}
	}
}
</script>


// WEBPACK FOOTER //
// Address.vue?75d73174